<template lang='pug'>
.img-container
  a(v-if='content.attributes["link_url"] !== ""' :href='content.attributes["link_url"]')
    img.res-image(:src='content.attributes["image_url"]' :alt='content.attributes["alt_text"]')
  img.res-image(v-else :src='content.attributes["image_url"]' :alt='content.attributes["alt_text"]')
</template>
<script>
import { Content } from '../../props'

export default {
  props: {
    content: { type: Content, default: () => new Content({}) }
  }
}
</script>
<style lang='scss' scoped>
.img-container {
  @include media-breakpoint-only(xs) {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.res-image {
  width: 100%;
  height: auto;
}
</style>
